import { render, staticRenderFns } from "./DoughnutRegistrationTalents.vue?vue&type=template&id=0d3bc7bc"
import script from "./DoughnutRegistrationTalents.vue?vue&type=script&lang=js"
export * from "./DoughnutRegistrationTalents.vue?vue&type=script&lang=js"
import style0 from "./DoughnutRegistrationTalents.vue?vue&type=style&index=0&id=0d3bc7bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports